import launchDarklyService from '@we-are-ocus/ocus-components/src/services/LaunchDarklyService';

export default async function launchDarkly({ app }) {
  const { user } = app.$auth;
  if (user) {
    const options = {
      diagnosticOptOut: true,
    };

    // user email
    user.email = user?.attributes?.email;

    // user firstname
    user.firstname = user?.attributes?.firstname;

    // user lastname
    user.lastname = user?.attributes?.lastname;

    // user locals
    user.locale = user?.attributes?.locale;

    // user roles
    const rolesList = user?.relationships?.roles?.data || [];
    user.roles = rolesList.map(({ attributes }) => attributes?.name);

    // user country
    user.countryCode = user?.relationships?.organizations?.data[0]
      ?.relationships?.addresses?.data[0]?.attributes?.country_code;

    // user state
    user.state = user?.relationships?.organizations?.data[0]
      ?.relationships?.addresses?.data[0]?.attributes?.state;

    // User product_subtype
    user.skills = user?.relationships?.product_subtypes?.data?.map(
      // eslint-disable-next-line
      ({ attributes }) => `${attributes.product_type_code} ${attributes.code} ${attributes.qualification}`
      );

    // user organization ready prop
    user.ready = user?.relationships?.organizations?.data[0]?.attributes?.ready;

    launchDarklyService.init({
      launchDarklyId: app.$config.launchDarklyClientSideId,
      user,
      options,
    });
  }
}
